/**
 * UTF-16 Encoding.
 *
 * @public
 */
export const UTF_16 = 'utf-16'
